<form
  id="informations-bien-form"
  class="px-4"
  [formGroup]="informationsBienForm"
>
  <div class="mb-3">
    <p-textarea
      [formControl]="this.informationsBienForm.controls.description"
      id="description"
      name="description"
      label="Description du bien"
      [maxLength]="2500"
      [showCounter]="true"
      (input)="descriptionChanged($event)"
    ></p-textarea>
  </div>

  <div class="mb-3">
    <p-textarea
      [formControl]="this.informationsBienForm.controls.surroundingsDescription"
      id="surroundingsDescription"
      name="surroundingsDescription"
      label="Description de l’emplacement / environnement"
      [maxLength]="2500"
      [showCounter]="true"
      (input)="surroundingsDescriptionChanged($event)"
    ></p-textarea>
  </div>

  <div class="row mb-3">
    <div class="col-6">
      <p-input
        [formControl]="this.informationsBienForm.controls.viewingDate"
        type="date"
        id="viewingDate"
        name="viewingDate"
        label="Date de la visite"
        (input)="viewingDateChanged($event)"
      ></p-input>
    </div>
    <div class="col-6">
      <p-input
        [formControl]="this.informationsBienForm.controls.occupation"
        id="occupation"
        name="occupation"
        label="Etat d’occupation"
        placeholder="Ex: libre, ..."
        (input)="occupationChanged($event)"
      ></p-input>
    </div>
  </div>

  <div class="mb-3">
    <p-input
      [formControl]="this.informationsBienForm.controls.condition"
      id="condition"
      name="condition"
      label="Etat du bien et travaux à prévoir"
      placeholder="Ex: neuf,  sans travaux à prévoir"
      (input)="conditionChanged($event)"
    ></p-input>
  </div>

  <div class="mb-3">
    <p-textarea
      [formControl]="this.informationsBienForm.controls.comments"
      id="comments"
      name="comments"
      label="Commentaires"
      [maxLength]="2500"
      [showCounter]="true"
      (input)="commentsChanged($event)"
    ></p-textarea>
  </div>
</form>
